import React from 'react';
import PropTypes from 'prop-types';
import './Legend.css';

const Legend = ({title, items, activeLayer, isMultiple = false, legendIndex = 0 }) => {
    if (!items || items.length === 0) return null;

    // Determine if this is a policy type legend based on title
    const isPolicyTypeLegend = title === "Policy Types";

    // Calculate bottom position for multiple legends
    const getBottomPosition = () => {
        if (!isMultiple) return undefined;
        const basePosition = 30;
        const spacing = 220; // Space between legends (closer spacing)
        return `${basePosition + (legendIndex * spacing)}px`;
    };

    return (
        <div 
            className={`legend-container ${isMultiple ? 'legend-multiple' : ''}`}
            style={isMultiple ? { bottom: getBottomPosition() } : {}}
        >
            <h3 className="legend-title">
                {isPolicyTypeLegend ? "Policy Types Legend" : title}
            </h3>
            <div className="legend-items">
                {items.map((item) => (
                    <div key={item.label} className="legend-item">
                        <div
                            className="legend-color"
                            style={{ backgroundColor: item.color}}
                        />
                        <span className="legend-label">{item.label}</span>
                    </div>
                ))}
            </div>
            {isPolicyTypeLegend && items.length > 0 && (
                <div className="legend-footer">
                    <small>Showing {items.length} policy types</small>
                </div>
            )}
        </div>
    );
};

Legend.propTypes = {
    title: PropTypes.string.isRequired,
    items: PropTypes.arrayOf(
        PropTypes.shape({
            color: PropTypes.string.isRequired,
            label: PropTypes.string.isRequired
        })
    ).isRequired,
    activeLayer: PropTypes.string,
    isMultiple: PropTypes.bool,
    legendIndex: PropTypes.number
};

export default Legend;
 